import styled from "styled-components";
import { motion } from "framer-motion";

export const SelectWrapper = styled(motion.div)`
    width: 100%;
    height: 60px;
    position: relative;

    label {
        font-size: 13px;
        font-weight: 500;
        color: var(--text-color);
        gap: 5px;
        display: flex;
    }

    span.InputWrapper__obrigatorio {
        color: var(--text-color-light);
        font-weight: 400;
        font-size: 11px;
    }

    div.SelectWrapper__campo {
        width: 100%;
        height: 40px;
        border: thin solid var(--border-color);
        border-radius: 10px;
        display: flex;
        align-items: center;
        gap: 10px;
        box-sizing: border-box;
        padding: 0 10px;
        cursor: text;

        svg.SelectWrapper__campo__icon_talhao {
            width: 30px;
            height: 30px;
        }
        
        :is([data-error = true]) {
            border-color: #ff4d4f;
            outline: thin solid rgba(255, 117, 87, 0.2);
        }
    }
    :is([data-disabled = true]) div.SelectWrapper__campo {
        background-color: var(--disabled-color);
        opacity: 0.8;
        cursor: not-allowed;
    }
    div.SelectWrapper__campo:focus-within {
        border: thin solid var(--primary-color);
        outline: thin solid rgba(93, 165, 125, 0.2);
    }

    .SelectWrapper__campo__icon {
        opacity: 0.4;
        cursor: text;
    }

    div.SelectWrapper__campo:is([data-error = true]) .SelectWrapper__campo__icon {
        color: #ff4d4f;
    }

    input.SelectWrapper__campo__input {
        width: calc(100% - 5px);
        height: 100%;
        border: none;
        color: var(--text-color);
        font-size: 14px;
    }
    input.SelectWrapper__campo__input::placeholder {
        color: rgba(0,0,0,0.25);
        font-size: 14px;
    }
    input.SelectWrapper__campo__input:disabled {
        cursor: not-allowed;
    }

    div.SelectWrapper__icons {
        display: flex;
    }

    button.SelectWrapper__campo__limpar {
        background-color: transparent;
        border: none;
        cursor: pointer;
        opacity: 0.45;
    }
    button.SelectWrapper__campo__limpar:hover {
        opacity: 1;
    }

    button.SelectWrapper__campo__arrow {
        border: none;
        background-color: transparent;
        cursor: text;
        opacity: 0.5;
        transition: .2s;
    }  
    :is([data-disabled = true]) button.SelectWrapper__campo__arrow {
        cursor: not-allowed;
    }
    div.SelectWrapper__campo:focus-within button.SelectWrapper__campo__arrow {
        transform: rotate(180deg);
    }  

    div.SelectWrapper__lista {
        position: absolute;
        left: 0;
        top: 57px;
        /* top: 61px; */
        margin-top: 2px;
        width: 100%;
        max-height: 50vh;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
        transform-origin: top;
        overflow-y: auto;
        z-index: 999;

        :is([data-haslabel = false]) {
            top: 40px;
        }
    }

    span.SelectWrapper__error {
        font-weight: 500;
        font-size: 11px;
        color: #ff4d4f;
        display: flex;
        line-height: 12px;
    }

`